import AuthService from '@/services/accAuthService'
import { UserRegisterModel } from '@/models/authentication/userRegisterModel'
import AuthOkResult from '@/models/authentication/authResultModel';
import customLocalStorage from '@/config/customLocalStorage';
import RegisterSupplementModel from '@/models/authentication/registerSupplement';
import store from '..';

export const auth = {
  namespaced: true,
  state: {
    user: null,
    registerModel: new UserRegisterModel(),
    confirmedEmail: "",
    userSupplementInfo: null,
    userLocation: null,
    userProfile: null,
    userNotifications: null,
  },
  getters: {
    getUser: (state: any) => {
      return state.user;
    },
    getRegisterModel: (state: any) => {
      return state.registerModel;
    },
    getUserSupplementInfo: (state: any) => {
      return state.userSupplementInfo;
    },
    getUserLocation: (state: any) => {
      return state.userLocation;
    },
    getUserprofile: (state: any) => {
      return state.userProfile;
    },
    getUserNotifications: (state: any) => {
      return state.userNotifications;
    },
  },
  actions: {
    clear({ commit }: any) {
      commit("clear");
    },
    login({ dispatch, commit }: any, user: any) {
      dispatch('clearAll', null, { root: true })
        .catch((error: any) => console.log(error));

      customLocalStorage.clear();

      return AuthService.login(user).then(
        async (response) => {
          commit('loginSuccess', response.data);

          return Promise.resolve(response);
        },
        error => {
          commit('loginFailure', error.response.data.user);
          
          return Promise.reject(error);
        }
      )
    },
    refresh({ commit }: any) {
      AuthService.refreshToken().then((success: any) => {
        return Promise.resolve(success);
      }).catch((error: any) => {
        return Promise.reject(error);
      });
    },
    logout({ dispatch, commit }: any,) {
      AuthService.logout().then((response: any) => {
        dispatch('clearAll', null, { root: true })
          .catch((error: any) => console.log(error));

        customLocalStorage.clear();
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    confirmEmail({ commit }: any, { userId, etoken }: any) {
      return AuthService.confirmEmail(null, { userId, etoken })
        .then((response: any) => {
          customLocalStorage.removeItem("rt");
          
          return Promise.resolve(response);
        },
          error => {
            commit('loginFailure', error.response.data.user);

            return Promise.reject(error);
          }
        );
    },
    updateUser({ commit }: any, user: any) {
      commit("updateUser", user);
    },
    resetPassword({ commit }: any, resetModel: any) {
      return AuthService.resetPassword(resetModel);
    },
    restorePassword({ commit }: any, { email }: any) {
      return AuthService.restorePassword({ email });
    },
    register({ commit }: any, user: UserRegisterModel) {
      const rt: string = customLocalStorage.getItem("rt") as string;
      
      return AuthService.register(user, { rt: rt })
        .then(
          response => {
            commit('registerSuccess', response.data);

            return Promise.resolve(response);
          },
          error => {
            commit('registerFailure');

            return Promise.reject(error);
          }
        );
    },
    getUserProfile({ commit }: any) {
      return AuthService.getUserProfile().then(
        response => {
          commit('setUserProfile', response.data);

          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    resendActivation({ commit }: any, email: string) {
      return AuthService.resendActivation({ email: email });
    },
    supplementUserInfo({ commit }: any, supplementInfo: RegisterSupplementModel) {
      return AuthService.supplementUserInfo(supplementInfo)
        .then(
          (response: any) => {
            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    getUser({ commit }: any) {
      return AuthService.getUser()
        .then(
          (response: any) => {
            commit('setUser', response.data);

            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },    
    getUserInfo({ commit }: any) {
      return AuthService.getUserInfo()
        .then(
          (response: any) => {
            commit('setUser', response.data);

            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    getUserByUserName({ commit }: any, data: any) {
      return AuthService.getUserByUserName(data)
        .then(
          (response: any) => {
            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    updateUserInfo({ commit }: any, data: any) {
      return AuthService.updateUserInfo(data)
        .then(
          (response: any) => {
            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    saveUserLocation({ commit }: any, data: any) {
      return AuthService.saveUserLocation(data)
        .then(
          (response: any) => {
            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    getUserLocation({ commit }: any) {
      return AuthService.getUserLocation()
        .then(
          (response: any) => {
            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    switchCurrentRole({ dispatch, commit }: any, { currentRole, newRole }: any) {
      return AuthService.switchCurrentRole(currentRole, newRole).then(
        async (response: any) => {
          dispatch('clearAll', null, { root: true })
            .catch((error: any) => console.log(error));

          customLocalStorage.clear();
          commit('loginSuccess', response.data);

          await store.dispatch('states/initStates')
            .catch((error) => console.log(error));

          return Promise.resolve(response);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      );
    },
    bumpUpReferrerForUser({ commit }: any) {
      return AuthService.bumpUpReferrerForUser()
        .then(
          (response: any) => {
            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    getUserNotifications({ commit }: any) {
      return AuthService.getUserNotifications()
        .then(
          (response: any) => {
            commit('setUserNotifications', response.data);

            return Promise.resolve(response.data);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    saveUserNotifications({ commit }: any, data: any) {
      return AuthService.saveUserNotifications(data)
        .then(
          (response: any) => {
            commit('setUserNotifications', response.data);

            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
    updateUserNotifications({ commit }: any, data: any) {
      return AuthService.updateUserNotifications(data)
        .then(
          (response: any) => {
            commit('setUserNotifications', response.data);
            
            return Promise.resolve(response);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
    },
  },
  mutations: {
    clear(state: any) {
      state.user = null;
      state.registerModel = new UserRegisterModel();
      state.confirmedEmail = "";
      state.userSupplementInfo = null;
      state.userLocation = null;
      state.userProfile = null;
      state.userNotifications = null;
    },    
    setUser(state: any, user: any) {
      state.user = { ...user };
    },
    loginSuccess(state: any, response: AuthOkResult) {
      state.user = response.user;
      customLocalStorage.setItem("token", JSON.stringify(response.token));
    },
    loginFailure(state: any, user: any) {
      state.user = user;
    },
    registerSuccess(state: any, response: AuthOkResult) {
      state.user = response.user;
    },
    registerFailure(state: any) {
    },
    updateUser(state: any, user: any) {
      state.user = user;
    },
    setUserSupplementInfo(state: any, info: any) {
      state.userSupplementInfo = { ...info };
    },
    setUserLocation(state: any, userLocation: any) {
      state.userLocation = { ...userLocation };
    },
    setUserProfile(state: any, profile: any) {
      state.userProfile = { ...profile };
    },
    setUserNotifications(state: any, userNotifications: any) {
      state.userNotifications = userNotifications;
    },
  }
};